import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import moment from "moment";
// Components
import { CustomerButton } from "../../Component/Button";
import { ArrowBtn } from "../../Component/Base";

// Image
import carPlaceholderImage from "../../../Assets/Common/carPlaceholder.png";
import { useDispatch, useSelector } from "react-redux";
import { Modal } from "antd";
import { CustomerAntModal, DateRangePicker, LocationPicker, NoDataYet } from "../../Component/BookingBase";
import { useNavigate } from "react-router-dom";
import { HomePageCarList } from "../../../Redux/Car";
import { carImageUrl, momentDateTimeFormat } from "../../../utils";

//TransLation
import { useTranslation } from "react-i18next";
import { ListLocation } from "../../../Redux/Location";
import { carDetailsNoCar } from "../../Component/ImageList";
import BookingIcon from "../../Assets/BookingIcon";

// Used For This Components
const MeetSomeMoreCarList = ({ nameOfClass, detail, data, openModalUpdate, setUpdateData, handleCarIndex }) => {
  const { t } = useTranslation();
  const UpdateModelOpenerHandler = (e) => {
    e.preventDefault();
    setUpdateData(data);
    openModalUpdate();
    handleCarIndex(detail?._id);
  };
  return (
    <div className={`${nameOfClass}`}>
      {detail?.photos?.length === 0 ? (
        <img src={carPlaceholderImage} alt="" className="img-fluid mb-3" />
      ) : (
        detail?.photos?.map((ele, index) => {
          return (
            <img
              src={`${carImageUrl}/${ele?.url}`}
              alt=""
              className={`img-fluid mostPopularBookingImage mb-3 ${index !== 0 ? "d-none" : ""}`}
              key={index}
              onError={(event) => (event.target.src = carDetailsNoCar)}
            />
          );
        })
      )}

      <h4 className="ff_md f20 txt-primary">
        {detail?.brand?.name} {detail?.modelName}
      </h4>
      <h4 className="ff_md f16">
        {detail?.modelYear} {t("labels.model")}
      </h4>
      <h4 className="ff_md f14">
        €{detail?.hourlyRate} {t("labels.perHour")}
      </h4>
      <div className="pt-2 pt-sm-4 text-center homecheckavailability">
        <CustomerButton nameOfClass="ff_bd f14 h48 c-primary border-n text-white px-5 text-capitalize" pressHandler={UpdateModelOpenerHandler}>
          {t("buttons.bookNow")}
        </CustomerButton>
      </div>
    </div>
  );
};

const MeetSomeMoreCar = () => {
  const [carIndex, setCarIndex] = useState(null);
  const [isModalOpen, setIsModelOpen] = useState(false);
  const [modalPurpose, setModalPurpose] = useState(0);
  const [updateData, setUpdateData] = useState({});

  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { homeCarList } = useSelector((state) => state.car);
  useEffect(() => {
    if (homeCarList === undefined) dispatch(HomePageCarList());
  }, [homeCarList, dispatch]);

  const cancelHandler = () => {
    setIsModelOpen(false);
    setModalPurpose(0);
  };

  const openModalUpdate = () => {
    setModalPurpose(1);
    setIsModelOpen(true);
  };

  const settings = {
    // className: "center",
    centerMode: true,
    infinite: false,
    slidesToShow: 1,
    nextArrow: <ArrowBtn type={"Next"} />,
    prevArrow: <ArrowBtn type={"Prev"} />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const handleCarIndex = (newIndex) => {
    setCarIndex(newIndex);
  };

  return (
    <div className="MeetSomeMoreCar pt-0 pt-md-4 pb-4 pb-md-5 overflow-hidden">
      <div className="container mb-5">
        <h4 className="ff_bd f38 text-center MeetSomeMoreCarSectionHeading txt-primary ">
          {t("customer.homePage.headers.meetSomeCars1")} <br className="d-lg-none" /> {t("customer.homePage.headers.meetSomeCars2")}
        </h4>
        <p className="ff_rg f14 text-center MeetSomeMoreCarDescription">
          {t("customer.homePage.subHeaders.someOfCar")}
          <br />
          {t("customer.homePage.subHeaders.peopleShare")}
        </p>
      </div>

      <div className="MeetSomeMoreCarBackground">
        {homeCarList !== undefined && (
          <Slider {...settings} className="MeetSomeMoreCarList mt-5">
            {homeCarList?.map((ele, index) => (
              <MeetSomeMoreCarList
                nameOfClass="text-center"
                detail={ele}
                openModalUpdate={openModalUpdate}
                setUpdateData={setUpdateData}
                key={index}
                handleCarIndex={handleCarIndex}
              />
            ))}
          </Slider>
        )}

        {homeCarList && homeCarList?.length === 0 && (
          <NoDataYet svg={BookingIcon?.NoDataFound} description={"No our top rated car added yet"} className={"py-5"} className2={"py-5"} />
        )}
      </div>

      <CarBookSearchModel isOpen={isModalOpen} cancelHandler={cancelHandler} carIndex={carIndex} modalUID={"is2"} />
    </div>
  );
};

export default MeetSomeMoreCar;

export const CarBookSearchModel = ({ isOpen, cancelHandler, carIndex, modalUID }) => {
  const [error, setError] = useState({ pickUpLocationMeetModel: undefined, dropOffLocationMeetModel: undefined, time: undefined, common: undefined });
  const [pickUpLocation, setPickUpLocation] = useState();
  const [dropOffLocation, setDropOffLocation] = useState();
  const [pickUpDate, setPickUpDate] = useState(null);
  const [dropOffDate, setDropOffDate] = useState(null);
  // selector
  const { homeCarList } = useSelector((state) => state.car);
  const { pickUpList, dropOffList } = useSelector((state) => state.location);
  const { booking } = useSelector((state) => state.setting);
  const { staticLoading } = useSelector((state) => state.loading);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const cancelSuperHandler = (e) => {
    e.preventDefault();
    cancelHandler();
    setPickUpLocation();
    setDropOffLocation();
    setPickUpDate(null);
    setDropOffDate(null);
    setError({ pickUpLocationMeetModel: undefined, dropOffLocationMeetModel: undefined, time: undefined, common: undefined });
  };

  const addHandler = () => {
    let flag = 0,
      err = { pickUpLocation: undefined, dropOffLocation: undefined, time: undefined, common: undefined };

    if (pickUpLocation === undefined) {
      err[`pickUpLocationMeetModel${modalUID}`] = "Please select a pick-up location";
      flag = 1;
    } else {
      err[`pickUpLocationMeetModel${modalUID}`] = undefined;
    }
    if (dropOffLocation === undefined) {
      err[`dropOffLocationMeetModel${modalUID}`] = "Please select a drop-off location";
      flag = 1;
    } else {
      err[`dropOffLocationMeetModel${modalUID}`] = undefined;
    }
    // Time Error
    if (pickUpDate === null || dropOffDate === null) {
      err["time"] = "Please select appropriate time";
      flag = 1;
    } else {
      err["time"] = undefined;
    }

    if (flag == 0) {
      let temp = moment(dropOffDate, momentDateTimeFormat).diff(moment(pickUpDate, momentDateTimeFormat), "day");
      if (temp > booking?.day?.max) err["common"] = `${t("error.maximumBooking")} ${booking?.day?.max} ${t("labels.days")}`;
      else if (temp < booking?.day?.min) err["common"] = `${t("error.minimumBooking")} ${booking?.day?.min} ${booking?.day?.min <= 1 ? t("labels.perDay") : t("labels.days")}`;
      else {
        setError({ pickUpLocationMeetModel: undefined, dropOffLocationMeetModel: undefined, time: undefined, common: undefined });

        if (carIndex) dispatch({ type: "PRIORITY_CAR_ID", payload: carIndex });
        navigate(
          `/search/${btoa(
            encodeURI(
              JSON.stringify({
                pickUpLocation,
                dropOffLocation,
                pickUpDate,
                dropOffDate,
              })
            )
          )}/${carIndex ? carIndex : "undefined"}`
        );
      }
      setError(err);
    } else setError(err);
  };
  useEffect(() => {
    if (pickUpList === undefined) dispatch(ListLocation("PICKUP"));
    if (dropOffList === undefined) dispatch(ListLocation("DROPOFF"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Modal
      open={isOpen}
      onOk={addHandler}
      maskClosable={false}
      onCancel={cancelSuperHandler}
      footer={[]}
      className="modelStaticPage modelMaxHeight customerAntModal"
      closable={true}
      centered={true}
    >
      <h3 className="text-center mt-0 txt-primary ff_bd f24 responsiveModalLabel mb-0">{t("labels.bookCar")}</h3>
      <div className="row">
        <LocationPicker
          nameOfClass={"col-12 col-md-12"}
          label={t("customer.homePage.labels.pickUpLoc")}
          locationList={pickUpList}
          uid={`pickUpLocationMeetModel${modalUID}`}
          locationId={pickUpLocation}
          setLocationId={setPickUpLocation}
          placeholderText={t("customer.homePage.defaultFormInput.choosePickUp")}
          error={error}
          setError={setError}
        />
        <LocationPicker
          nameOfClass={"col-12 col-md-12"}
          label={t("customer.homePage.labels.dropOffLoc")}
          locationList={dropOffList}
          uid={`dropOffLocationMeetModel${modalUID}`}
          locationId={dropOffLocation}
          setLocationId={setDropOffLocation}
          placeholderText={t("customer.homePage.defaultFormInput.chooseDropOff")}
          error={error}
          setError={setError}
        />

        <div className="col-12">
          <DateRangePicker
            nameOfClass={"col-12 col-md-12"}
            label={t("customer.homePage.labels.pickAndReturnDate")}
            startDate={pickUpDate}
            setStartDate={setPickUpDate}
            endDate={dropOffDate}
            setEndDate={setDropOffDate}
          />
          <span className="small text-danger error-message mt-1">
            {!pickUpDate && !dropOffDate && t(error?.common)}
            {!pickUpDate && !dropOffDate && t(error?.time)} &nbsp;
          </span>
        </div>
      </div>

      <CustomerAntModal
        addTitle={
          staticLoading ? (
            <div className="d-block">
              <div className="spinner-border" role="status"></div>
            </div>
          ) : (
            t("buttons.proceed")
          )
        }
        cancelTitle={t("buttons.cancel")}
        addSuperHandler={() => addHandler()}
        cancelSuperHandler={cancelSuperHandler}
      />
    </Modal>
  );
};
